import { render, staticRenderFns } from "./Statements-table.vue?vue&type=template&id=0a960a96"
import script from "./Statements-table.vue?vue&type=script&lang=js"
export * from "./Statements-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports